export enum ChatItemType {
  Notification = "NotificationChatItem",
  UserEvent = "UserEventChatItem",
  Meeting = "MeetingChatItem",
  MeetingEvent = "MeetingEventChatItem",
  MeetingScheduler = "MeetingSchedulerChatItem",
  CallEvent = "CallEventChatItem",
  CobrowsingEvent = "CobrowsingEventChatItem",
  UserText = "UserTextChatItem",
  FakeUserText = "FakeUserTextChatItem",
  Note = "NoteChatItem",
  StatusChange = "StatusChangeChatItem",
  DateSeparator = "DateSeparatorChatItem",
  ContactEnquiry = "ContactEnquiryChatItem",
  Empty = "EmptyChatItem",
  Group = "ChatItemGroup",
  CTAEvent = "CTAEvent",
  WidgetFormEvent = "WidgetFormEventChatItem",
  TagsChange = "TagsChangeChatItem",
  TopicsChange = "TopicsChangeChatItem",
  RoomSummary = "RoomSummaryChatItem"
}
